import React from "react";

export default function Step8() {
  return (
    <div>
      <div className="flex gap-2.5">
        <div className="shrink-0 border border-icon/50 w-8 h-8 rounded-full flex justify-center items-center text-lg font-semibold text-icon">
          8
        </div>
        <h1 className="">
          Agora é hora de baixar gratuitamente o aplicativo da XM. <br />
          <b>Basta pesquisar por XM na busca.</b> Disponível para Android e iOS.
        </h1>
      </div>
      <div className="mt-2.5 ml-[42px]">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/steady-gainz.firebasestorage.app/o/OpenAccount%2FIMG_3613.jpg?alt=media&token=875acb48-3e82-43f4-a3fa-71a5cd6656e8"
          className="w-72"
          alt=""
        />
      </div>
    </div>
  );
}
